// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { UserService } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Service/User';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useModuleParty } from '../../../../contexts/ModuleContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

export const useCollateralUserService: () => UseQueryResult<
  TemplateContract<UserService> | null,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data;
  const party = useModuleParty();

  return useQueryWithOptions({
    queryKey: ['queryCollateralUserService', operator, party],
    select: (data: TemplateContract<UserService>[]) =>
      data.find((d) => d.payload.operator === operator && d.payload.user === party) || null,
    queryFn: async (_, options) => {
      if (!operator) {
        throw new Error('Operator party was undefined in useUserService');
      }
      return ledgerApi.query(options, UserService);
    },
  });
};
